import { MEHRSAN_PROCESS_STATUSES } from "./mehrsanOperationsConstants";

export const getEntityId = (entity) =>
  entity?.id ?? entity?.Id ?? null;

export const getStatusLabel = (status, statusTitle) => {
  if (statusTitle && String(statusTitle).trim()) return statusTitle;
  const value = Number(status);
  if (Number.isNaN(value)) return "نامشخص";
  const match = MEHRSAN_PROCESS_STATUSES.find((s) => s.value === value);
  return match?.label || "نامشخص";
};

export const getAuthorName = (fullName) => {
  const name = fullName && String(fullName).trim();
  return name || "نامشخص";
};

/** Client-side safety net: API should already return descending CreateOn. */
export const normalizeTimelineLogs = (logs) => {
  if (!Array.isArray(logs)) return [];
  const seen = new Set();
  const unique = [];
  logs.forEach((log) => {
    const id = getEntityId(log);
    const key = id != null ? `id:${id}` : `row:${unique.length}`;
    if (seen.has(key)) return;
    seen.add(key);
    unique.push(log);
  });
  return unique.sort((a, b) => {
    const aTime = new Date(a.createOn ?? a.CreateOn ?? 0).getTime();
    const bTime = new Date(b.createOn ?? b.CreateOn ?? 0).getTime();
    if (bTime !== aTime) return bTime - aTime;
    return (getEntityId(b) ?? 0) - (getEntityId(a) ?? 0);
  });
};

export const getAttachmentUrl = (log) =>
  log?.attachmentUrl ?? log?.AttachmentUrl ?? null;

export const buildInitialLogForm = (process) => ({
  status: Number(process?.currentStatus ?? process?.CurrentStatus ?? 1),
  actionTitle: "",
  description: "",
  nextFollowUpDate: "",
  referenceNumber: process?.referenceNumber ?? process?.ReferenceNumber ?? "",
  attachmentUrl: "",
});

export const emptyLogFormFields = () => ({
  actionTitle: "",
  description: "",
  nextFollowUpDate: "",
  attachmentUrl: "",
});

export const parseApiErrorMessage = (res, fallback) =>
  res?.message ?? res?.Message ?? fallback;

export const isMehrsanProcessClosed = (process) =>
  Boolean(process?.isCompleted ?? process?.IsCompleted);

export const hasMehrsanFinalStage = (process, logs = []) => {
  const current = Number(process?.currentStatus ?? process?.CurrentStatus);
  if (current === 6) return true;
  return (logs || []).some(
    (log) => Number(log.status ?? log.Status) === 6
  );
};

export const hasMehrsanCompletion = (process, logs = []) => {
  const current = Number(process?.currentStatus ?? process?.CurrentStatus);
  if (current === 4) return true;
  return (logs || []).some(
    (log) => Number(log.status ?? log.Status) === 4
  );
};

export const buildMehrsanStatusUpdateActionTitle = (status) => {
  const label = getStatusLabel(status);
  return `بروزرسانی وضعیت: ${label}`;
};
